import React from 'react';
import PollResult from './PollResult';

export default (props) => (
    <div>
        <h3 className="pollTitle">{props.poll.title}</h3>
        <PollResult options={props.poll.options} />
    </div>
);
